export function attachAppGlobals(mapping = {}) {
  if (typeof window === "undefined") {
    return;
  }
  Object.entries(mapping).forEach(([key, value]) => {
    if (!key) return;
    try {
      window[key] = value;
    } catch (error) {
      console.warn("app_global_attach_failed", {
        key,
        message: error instanceof Error ? error.message : String(error),
      });
    }
  });
}
